<app-alert-label text="Lowest Fare"></app-alert-label>
